import ReportStore from './vuexStore/index'
import B from './Branding'
import { pdf } from './Pdf'

const ReportHomeSearchPlugin = {
  install (Vue, { store }) {
    (function (options) {
      // 'new' an object
      const reportHomesearch = function () {
        // eslint-disable-next-line new-cap
        return new reportHomesearch.init()
      }

      // hidden within the scope of the IIFE and never directly accessible
      const testVar = 'This is a load test var'

      // prototype holds methods (to save memory space)
      reportHomesearch.prototype = {
        config: function () {
          console.log(`Report Library loaded successfully: ${testVar}`)
        },
        $B: B(),
        $pdf: pdf(),
      }

      // the actual object is created here, allowing us to 'new' an object without calling 'new', config options can be passed to here
      reportHomesearch.init = function () {
        store.registerModule('ReportStore', ReportStore)
        const self = this
        self.config()
      }

      // trick borrowed from jQuery so we don't have to use the 'new' keyword
      reportHomesearch.init.prototype = reportHomesearch.prototype

      // attach our Homesearch to the global object, and provide a shorthand '$hs' to ease our poor fingers
      Vue.prototype.reportHomesearch = reportHomesearch
      // Vue.$hs = Vue.prototype.reportHomesearch() // GLOBAL METHOD access with Vue.
      Vue.prototype.$reportHS = Vue.prototype.reportHomesearch() // INSTANCE METHOD access with this. config options can be passed FROM here
    }({}))
  },
}

export default ReportHomeSearchPlugin
